/**
 * Envío de la marcación autónoma (004 · US8 · T061; `contracts/staff-vpp.md` §5).
 *
 * `POST /marks/autonomous` es la ruta del marcador **sin conexión**: no hay challenge que pedir ni
 * turno que esperar, así que el flujo entero es una sola petición con los frames `FM1A` que la
 * cámara acumuló (`autonomous-frames.ts`).
 *
 * Es **autenticada** como todas las de la 004 (wiring §0.5): el cliente añade la cookie
 * `fermin_staff_session` y la cabecera `X-Fermin-Device` firmada con `id=`. Aquí no se redefine
 * ningún esquema: sale de `@fermin/contracts`.
 *
 * > **Nota de cableado.** Esta función vive en `src/camera/` y no en
 * > `src/features/attendance/api.ts` por propiedad de archivos entre lotes: `features/attendance/`
 * > lo lleva el lote de US2 y editarlo en paralelo provocaría un conflicto. Es un traslado de un
 * > archivo cuando los dos lotes estén cerrados; el contenido no cambia.
 */
import {
  AutonomousMarkResponseSchema,
  type AutonomousMarkBody,
  type AutonomousMarkResponse,
} from '@fermin/contracts';

import { api } from '../api/client';

/**
 * La clave de idempotencia **la genera Staff por intento** (FR-035a, decisión del clarify) y se
 * repite en los reintentos: el servidor la respeta y devuelve la misma marca en vez de crear otra.
 * Nunca la fabrica el servidor.
 */
export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}

export function submitAutonomousMark(body: AutonomousMarkBody): Promise<AutonomousMarkResponse> {
  return api.post('/marks/autonomous', { body, schema: AutonomousMarkResponseSchema });
}
